import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { IPayGapSignResponse } from 'model/interfaces';
import { useSettingsStore } from 'store';
import { getRtiTemplate } from 'services/rti/get-rti-template';
import { rtiTemplateDataToSettingsPatch } from 'utilities/rti-template-store-sync';

export const useSettingsService = () => {
  const { isPayGapsPositive, updatePayGapsPositive } = useSettingsStore();

  const formatPayGapSign = (value: string) => {
    let payGapValue = Number(value || 0);
    if (isPayGapsPositive) {
      return payGapValue * -1;
    }
    return payGapValue;
  };

  const fetchPayGapSign = () => {
    const config = {
      baseURL: ENV_VARS.API_URL,
      url: 'overview/paygapsettings',
      method: 'GET',
    };
    kf1AuthenticatedHttpClient<IPayGapSignResponse>(config).then(
      (response) => {
        if (response && response.data) {
          const { responseCode, data } = response.data;
          if (responseCode === 200 && data) {
            updatePayGapsPositive(
              data.payGapFlag,
              data.signThreshold,
              data.targetPayGap,
              data.maxIncrement,
            );
          }
        }
      },
      (error) => {
        console.error('fetchPayGapSign', error);
      },
    );
  };

  const fetchRtiTemplateToStore = () => {
    void getRtiTemplate()
      .then((res) => {
        if (res?.responseCode === 200 && res?.data) {
          useSettingsStore.getState().updateRtiSettings(rtiTemplateDataToSettingsPatch(res.data));
        } else {
          useSettingsStore.getState().updateRtiSettings({
            rtiTemplateLoaded: false,
            rtiIsEditAccess: false,
          });
        }
      })
      .catch((error) => {
        console.error('fetchRtiTemplateToStore', error);
        useSettingsStore.getState().updateRtiSettings({
          rtiTemplateLoaded: false,
          rtiIsEditAccess: false,
        });
      });
  };

  return { formatPayGapSign, fetchPayGapSign, fetchRtiTemplateToStore };
};
